export const RESIZE_ARTICLE = 'RESIZE_ARTICLE';
export const MOVE_ARTICLE = 'MOVE_ARTICLE';
export const ADD_ARTICLE_TO_GROUP = 'ADD_ARTICLE_TO_GROUP';
export const DELETE_ARTICLE_FROM_GROUP = 'DELETE_ARTICLE_FROM_GROUP';
export const EDIT_TITLE = 'EDIT_TITLE';
export const CROP_IMAGE = 'CROP_IMAGE';



/** WEBPACK FOOTER **
 ** ./src/actions/article.js
 **/